export const environment = {
  envName: 'test',
  production: false,

  clientId: 'a1298825-2acf-4a5d-ac05-e23f5913dfe7',
  redirectUri: `${location.protocol}//${location.hostname}${location.port && ':' + location.port}/`,
  audience: 'https://swd-test.azure.chevron.com',

  apiUrl: 'https://swd-api-test.azure.chevron.com/api',

  authority: 'https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26/v2.0',
  knownAuthorities: ['https://login.microsoftonline.com', 'https://sts.windows.net'],
  appInsightsInstrumentationKey: 'a4df0793-b44a-407b-a021-951c3a1f731b',
};
